import Hero from "../../frontend/components/Hero";
import CalculatorsImag1 from "../../assets/images/RelevantLifeTaxCalculator.jpg";
import RelevantLifeTaxCalculator from "../../frontend/components/calculators/RelevantLifeTaxCalculator";

const RelevantLifeTaxPage = () => {
  return (
    <div>
      <Hero
        title="Relevant Life Tax"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <RelevantLifeTaxCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default RelevantLifeTaxPage;
